import React, { useContext, useState } from "react";
import { Button, Card, Label, TextInput } from "flowbite-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import img from "../assets/images/logo1.png";
import apiRequest from "../utils/apiRequest";
import { Store } from "../context/store";
import { HiEye, HiEyeOff } from "react-icons/hi";

export function ResetPassword() {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  const { id } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  let [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleReset = async () => {
    if (!password || !confirmPassword) {
      setError("Both password fields are required");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      const url = `${baseUrl}/reset-password`;
      const body = { password };
      const { message } = await apiRequest(url, "POST", body, id);
      setSuccess(message);
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <title>Reset Password</title>
      <div className="login">
        <div className="container mx-auto">
          <div className="toast bg-[#fafafa]">
            <img src={img} className="h-14 " alt="Royalmines Logo" />
          </div>
          <div className="flex justify-center items-center h-screen">
            <Card className="w-3/4 md:w-1/2 lg:w-1/4 card">
              <h3 className="text-center font-extrabold text-2xl">
                Reset Password
              </h3>
              <p className="text-red-500 text-sm text-center">{error}</p>
              <p className="text-green-500 text-sm text-center">{success}</p>
              <div className="flex max-w-md flex-col gap-4">
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="password" value="New Password" />
                  </div>
                  <div className="relative">
                    <TextInput
                      id="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter new password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className="absolute inset-y-0 right-2 flex items-center cursor-pointer"
                      onClick={() => setShowPassword(!showPassword)} // Toggle visibility state
                    >
                      {showPassword ? (
                        <HiEyeOff className="text-gray-500" />
                      ) : (
                        <HiEye className="text-gray-500" />
                      )}
                    </span>
                  </div>
                </div>
                <div>
                  <div className="mb-2 block">
                    <Label
                      htmlFor="confirmPassword"
                      value="Confirm New Password"
                    />
                  </div>
                  <TextInput
                    id="confirmPassword"
                    type="password"
                    placeholder="Confirm new password"
                    required
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <Button
                  disabled={loading}
                  onClick={handleReset}
                  className="bg-#6eb5ff"
                >
                  {loading ? "Resetting..." : "Submit"}
                </Button>
              </div>
              <div className="flex justify-center">
                <Link to="/login">Back to Login</Link>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword; // Export the initial request component by default
